<app-table [data]="pendingToolReturns"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [headerBackgroundColor]="headerBackgroundColor"
           [showFilters]="showFilters"
           [hasTitle]="hasTitle"
           [isMaterial]="isMaterial"
           title="{{'lineSetter.pending-tool-returns.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'lineSetter.pending-tool-returns.table.columns.toolRequestName' | translate}}
                                [{{'lineSetter.pending-tool-returns.table.columns.line' | translate}}_
                                {{'lineSetter.pending-tool-returns.table.details-modal.createdDate' | translate }}]"
                      filterPlaceholder="{{'lineSetter.pending-tool-returns.table.filter.byToolRequestName' | translate}}"
                      filter="true"
                      field="ToolRequestName"
                      sortable="true">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.toolRequest.name }}</span>
        </ng-template>
    </app-table-column>

    <app-table-column header="{{'lineSetter.pending-tool-returns.table.columns.creator' | translate}}"
                      filterPlaceholder="{{'lineSetter.pending-tool-returns.table.filter.byCreator' | translate}}"
                      filter="true"
                      field="createdBy"
                      sortable="true">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.createdBy.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.status' | translate}}"
                      sortable="true"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.tickets.table.filter.placeholder.status' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
</app-table>
